// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Box from "../../atom/Atom_Box.bs.js";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../../atom/Atom_Row.bs.js";
import * as Util_Css from "../../../util/Util_Css.bs.js";
import * as Atom_Cell from "../../atom/Atom_Cell.bs.js";
import * as Atom_Text from "../../atom/Atom_Text.bs.js";
import * as Atom_Image from "../../atom/Atom_Image.bs.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Type_String from "../../../type/Type_String.bs.js";
import * as Atom_Text_Ds from "../../atom/Atom_Text_Ds.bs.js";
import * as Molecule_Sticker from "../../molecule/Molecule_Sticker.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";
import * as Organism_Teaser_Css_Identifier from "../teaser/Organism_Teaser_Css_Identifier.bs.js";
import * as Particle_Accessibility_Constant from "../../particle/Particle_Accessibility_Constant.bs.js";

var identifier = "broadcastItem";

function makeTitleStyle(variant) {
  return Atom_Text_Ds.Broadcast.toParent(Atom_Text_Ds.Broadcast.title(variant));
}

var subtitleStyle = Atom_Text_Ds.Broadcast.toParent(Atom_Text_Ds.Broadcast.subtitle);

var descriptionStyle = Atom_Text_Ds.Broadcast.toParent(Atom_Text_Ds.Broadcast.description);

var categorytyle = Atom_Text_Ds.Broadcast.category;

var dateStyle = Atom_Text_Ds.Teaser.toParent(Atom_Text_Ds.Teaser.date);

var pictureRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Util_Css.preserveAspectRatioRules("R16_9"));

var pictureAutoSize = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* NoResizing */3);

var pictureInitialWidth = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "initial");

var largeRules = Particle_Screen_Ds.make(undefined, undefined, undefined, [CssJs.display("initial")], undefined, [CssJs.display("none")]);

var smallRules = Particle_Screen_Ds.make(undefined, undefined, undefined, [CssJs.display("none")], undefined, [CssJs.display("initial")]);

var availabilityRules = Particle_Screen_Ds.make(undefined, undefined, undefined, [CssJs.display("initial")], undefined, [
      CssJs.display("none"),
      CssJs.flex({
            NAME: "num",
            VAL: 0.3
          })
    ]);

function Organism_Broadcast(Props) {
  var broadcast = Props.broadcast;
  var variantOpt = Props.variant;
  var variant = variantOpt !== undefined ? variantOpt : /* Default */1;
  var online = broadcast.online;
  var subtitle = broadcast.subtitle;
  var availability = online !== undefined ? online.label : "";
  var titleStyle = makeTitleStyle(variant);
  var image = React.createElement(Atom_Image.make, {
        accessibility: Particle_Accessibility_Constant.ariaHidden,
        alt: "",
        identifier: Organism_Teaser_Css_Identifier.img,
        src: [broadcast.image],
        style: /* Broadcast */2
      });
  var picture = React.createElement(Atom_Cell.make, {
        alignSelf: Particle_Screen_Constants.alignSelfCenter,
        autoSize: pictureAutoSize,
        width: pictureInitialWidth,
        children: null,
        rules: pictureRules
      }, image, broadcast.sticker !== undefined ? React.createElement(Molecule_Sticker.make, {
              text: "HIGHLIGHT",
              style: Molecule_Sticker.Molecule_Sticker_Ds.highlight,
              position: /* TopLeft */1
            }) : null);
  return React.createElement(Atom_Box.make, {
              autoSize: Particle_Screen_Constants.autoSizeNoResizing,
              children: React.createElement(Atom_Row.make, {
                    alignItems: Particle_Screen_Constants.alignItemsFlexStart,
                    autoSize: Particle_Screen_Constants.autoSizeAllPlaceAvailable,
                    children: null,
                    innerSpace: Particle_Screen_Constants.xsInnerSpace,
                    justifyContent: Particle_Screen_Constants.justifyContentSpaceBetween
                  }, React.createElement(Atom_Cell.make, {
                        justifyContent: Particle_Screen_Constants.justifyContentCenter,
                        alignSelf: Particle_Screen_Constants.alignSelfCenter,
                        children: React.createElement(Atom_Text.make, {
                              children: broadcast.schedule,
                              style: dateStyle
                            })
                      }), React.createElement(Atom_Cta.Link.Block.make, {
                        children: picture,
                        href: broadcast.url,
                        style: /* Broadcast */6
                      }), React.createElement(Atom_Column.make, {
                        alignItems: Particle_Screen_Constants.alignItemsFlexStart,
                        autoSize: Particle_Screen_Constants.autoSizeAllPlaceAvailable,
                        children: null,
                        justifyContent: Particle_Screen_Constants.justifyContentFlexStart
                      }, React.createElement(Atom_Cell.make, {
                            children: React.createElement(Atom_Text.make, {
                                  children: Curry._1(Type_String.Teaser.Title.toString, broadcast.title),
                                  identifier: Organism_Teaser_Css_Identifier.title,
                                  kind: "h3",
                                  style: titleStyle
                                })
                          }), React.createElement(Atom_Cell.make, {
                            children: React.createElement(Atom_Text.make, {
                                  children: Curry._1(Type_String.Teaser.Subtitle.toString, subtitle),
                                  identifier: Organism_Teaser_Css_Identifier.subtitle,
                                  style: subtitleStyle
                                }),
                            rules: largeRules
                          }), React.createElement(Atom_Cell.make, {
                            children: React.createElement(Atom_Text.make, {
                                  children: Curry._1(Type_String.Teaser.Subtitle.toString, subtitle),
                                  identifier: Organism_Teaser_Css_Identifier.subtitle,
                                  style: descriptionStyle
                                }),
                            rules: smallRules
                          }), React.createElement(Atom_Cell.make, {
                            children: React.createElement(Atom_Text.make, {
                                  children: broadcast.presseCategory,
                                  style: categorytyle
                                })
                          }), React.createElement(Atom_Cell.make, {
                            children: React.createElement(Atom_Text.make, {
                                  children: broadcast.shortDescription,
                                  style: descriptionStyle
                                }),
                            rules: largeRules
                          })), React.createElement(Atom_Cell.make, {
                        alignSelf: Particle_Screen_Constants.alignSelfCenter,
                        children: React.createElement(Atom_Text.make, {
                              children: availability
                            }),
                        rules: availabilityRules
                      }), React.createElement(Atom_Cell.make, {
                        alignSelf: Particle_Screen_Constants.alignSelfCenter,
                        children: React.createElement(Atom_Cta.Link.make, {
                              dataAnchor: true,
                              href: broadcast.downloadUrl,
                              style: {
                                TAG: /* DownloadLink */4,
                                _0: Particle_Spacer_Ds.makeAll("Zero"),
                                _1: {
                                  TAG: /* Main */0,
                                  _0: "Text"
                                }
                              }
                            }),
                        rules: largeRules
                      })),
              id: broadcast.id,
              identifier: identifier,
              width: Particle_Screen_Constants.oneHundredPctWidth
            });
}

var imageKind = /* Broadcast */2;

var make = Organism_Broadcast;

export {
  identifier ,
  makeTitleStyle ,
  subtitleStyle ,
  descriptionStyle ,
  categorytyle ,
  dateStyle ,
  imageKind ,
  pictureRules ,
  pictureAutoSize ,
  pictureInitialWidth ,
  largeRules ,
  smallRules ,
  availabilityRules ,
  make ,
}
/* subtitleStyle Not a pure module */
